export default __webpack_public_path__ + "static/media/breakfast_10.aceff834.jpg";